module.exports = __webpack_public_path__ + "img/preview-3.8aef723b.png";